import {
  Button,
  Card,
  CardBody,
  CardHeader,
  FormGroup,
  Input,
  Label,
} from 'reactstrap'
import Footer from './Footer'
import CreateJobCheckbox from './CreateJobCheckbox'
import { Link } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { getJobScreenings } from 'store/Recruitment/actions'
import { useSelector } from 'react-redux'
import { setJobProp } from 'store/Recruitment/actions'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faArrowsRotate,
  faPlus,
  faTrash,
} from '@fortawesome/free-solid-svg-icons'
import { v4 as uuidv4 } from 'uuid'
import { setAreYouSureModalData } from 'store/Recruitment/actions'
import Hints from 'views/pages/UIElements/Hints'
import { setAiInterviewIntroduction } from 'store/Recruitment/actions'
import { setAiInterviewConclusion } from 'store/Recruitment/actions'
import { setStopInterviewOnTabChange } from 'store/Recruitment/actions'
import { setAiQuestions } from 'store/Recruitment/actions'

function SecondSlide() {
  const dispatch = useDispatch()
  const {
    jobScreenings,
    jobProps,
    aiInterviewConclusion,
    aiInterviewIntroduction,
    stopInterviewOnTabChange,
    aiQuestions,
  } = useSelector((store) => store.recruitment)

  // const [aiQuestions, setAiQuestions] = useState([
  //   { id: uuidv4(), question: '', feedback: '', time_limit: 60 },
  // ])

  const addQuestion = () => {
    dispatch(
      setAiQuestions([
        ...aiQuestions,
        {
          id: uuidv4(),
          question: '',
          feedback: '',
          time_limit: 60,
          allow_input: 0,
        },
      ])
    )
  }

  const updateAiQuestion = (questionId, field, value) => {
    let questions = aiQuestions

    let newQuestions = questions.map((q) => {
      if (q.id !== questionId) {
        return q
      } else {
        return { ...q, [field]: value }
      }
    })
    dispatch(setAiQuestions(newQuestions))
  }

  useEffect(() => {
    dispatch(getJobScreenings())
  }, [dispatch])

  const handleCustomQuestionChange = (id, checked) => {
    const current = jobProps.find((job) => job.name === 'custom_questions')
    let newValue = current?.value || []

    if (checked) {
      if (!newValue.includes(id)) newValue = [...newValue, id]
    } else {
      newValue = newValue.filter((qid) => qid !== id)
    }

    dispatch(setJobProp({ name: 'custom_questions', value: newValue }))
  }

  const handleCheckboxChange = (val, _, name) => {
    dispatch(setJobProp({ value: val ? 1 : 0, name }))
  }

  return (
    <Card>
      <CardHeader className='d-flex align-items-center'>
        <p className='title w-50'>Job Checkboxes</p>
        <p className='title w-50 ml-5'>Questions Checkboxes</p>
      </CardHeader>
      <CardBody>
        <div className='d-flex align-items-start'>
          <div className='d-flex flex-wrap w-50' style={{ gap: '0rem 1rem' }}>
            <div className='w-50'>
              <p className='title mb-3'>Need to Ask ?</p>
              <CreateJobCheckbox
                label='Gender'
                name='gender'
                onChange={handleCheckboxChange}
              />
              <CreateJobCheckbox
                label='Date Of Birth'
                name='date_of_birth'
                onChange={handleCheckboxChange}
              />
              <CreateJobCheckbox
                label='Country'
                name='country'
                onChange={handleCheckboxChange}
              />
            </div>
            <div>
              <p className='title mb-3'>Need to show Option ?</p>
              <CreateJobCheckbox
                label='Profile Image'
                name='profile_image'
                onChange={handleCheckboxChange}
              />
              <CreateJobCheckbox
                label='Resume'
                name='resume'
                onChange={handleCheckboxChange}
              />
              <CreateJobCheckbox
                label='Cover Letter'
                name='cover_letter'
                onChange={handleCheckboxChange}
              />
              <CreateJobCheckbox
                label='Terms And Conditions'
                name='terms_and_conditions'
                onChange={handleCheckboxChange}
              />
            </div>
          </div>
          <div
            className='d-flex flex-wrap w-50 ml-5'
            style={{ gap: '0rem 1rem' }}
          >
            <div>
              <p className='title mb-3'>Custom Questions</p>
              {jobScreenings && jobScreenings.length
                ? jobScreenings.map((screening) => {
                    const selectedCustomQuestions =
                      jobProps.find((p) => p.name === 'custom_questions')
                        ?.value || []
                    const isChecked = selectedCustomQuestions.includes(
                      screening.id
                    )

                    return (
                      <CreateJobCheckbox
                        key={screening.id}
                        label={screening.question}
                        required={screening.is_required}
                        checked={isChecked}
                        onChange={(val) =>
                          handleCustomQuestionChange(screening.id, val)
                        }
                      />
                    )
                  })
                : null}

              <Link
                to='/job-screening'
                target='_blank'
                rel='noopener noreferrer'
              >
                <small>
                  <strong>Create custom question</strong>
                </small>
              </Link>
              <button
                onClick={() => dispatch(getJobScreenings())}
                className='btn btn-info ml-3 py-1'
                title='Refresh custom questions'
              >
                <FontAwesomeIcon icon={faArrowsRotate} />
              </button>
            </div>
          </div>
        </div>
        <Card className='my-5'>
          <CardBody>
            <p className='title'>AI Interview Setup</p>
            <p className='text-muted mt-2 mb-3'>
              Optionally add AI interview questions here if you plan to automate
              the interview process for this job post in the future. If
              candidates will be interviewed live by HR, you can skip this step.
            </p>

            <FormGroup className='ml-0'>
              <Input
                id={`introduction`}
                name='introduction'
                placeholder='Introduction Message | e.g., Hello and welcome to your AI interview for this position. Please answer the following questions clearly and thoughtfully.'
                type='textarea'
                rows={5}
                value={aiInterviewIntroduction}
                onChange={(e) =>
                  dispatch(setAiInterviewIntroduction(e.target.value))
                }
              />
            </FormGroup>

            <FormGroup className='ml-0'>
              <Input
                id={`conclusion`}
                name='conclusion'
                placeholder='Conclusion Message |  e.g., Thank you for completing the interview. We’ll review your answers and get back to you shortly.'
                type='textarea'
                rows={5}
                value={aiInterviewConclusion}
                onChange={(e) =>
                  dispatch(setAiInterviewConclusion(e.target.value))
                }
              />
            </FormGroup>

            {aiQuestions && aiQuestions.length
              ? aiQuestions.map((question) => (
                  <div
                    key={question.id}
                    className='d-flex align-items-center justify-content-between'
                    style={{ gap: '1rem' }}
                  >
                    <FormGroup className='ml-0' style={{ flexGrow: 1 }}>
                      <Input
                        id={`question${question.id}`}
                        name='question'
                        placeholder='Question'
                        type='textarea'
                        rows={3}
                        value={
                          aiQuestions?.find((q) => q?.id === question?.id)
                            ?.question || ''
                        }
                        onChange={(e) =>
                          updateAiQuestion(
                            question.id,
                            'question',
                            e.target.value
                          )
                        }
                      />
                    </FormGroup>
                    <FormGroup className='ml-0' style={{ flexGrow: 1 }}>
                      <Input
                        id={`feedback${question.id}`}
                        name='feedback'
                        placeholder='Feedback (optional) | Help the AI by describing what a good answer should include'
                        type='textarea'
                        rows={3}
                        value={
                          aiQuestions?.find((q) => q?.id === question?.id)
                            ?.feedback || ''
                        }
                        onChange={(e) =>
                          updateAiQuestion(
                            question.id,
                            'feedback',
                            e.target.value
                          )
                        }
                      />
                    </FormGroup>
                    <FormGroup className='ml-0' style={{ width: '120px' }}>
                      <div className='d-flex align-items-center justify-content-between mb-1'>
                        <Label
                          for='question-timer'
                          className='small text-muted mb-0'
                        >
                          Time Limit
                        </Label>
                        <button
                          type='button'
                          className={`btn btn-sm px-2 py-0 ${
                            (aiQuestions?.find((q) => q?.id === question?.id)
                              ?.time_limit || 0) > 0
                              ? 'btn-success'
                              : 'btn-outline-secondary'
                          }`}
                          style={{ fontSize: '10px', lineHeight: '1.2' }}
                          onClick={() =>
                            updateAiQuestion(
                              question.id,
                              'time_limit',
                              (aiQuestions?.find((q) => q?.id === question?.id)
                                ?.time_limit || 0) > 0
                                ? 0
                                : 60
                            )
                          }
                          title={
                            (aiQuestions?.find((q) => q?.id === question?.id)
                              ?.time_limit || 0) > 0
                              ? 'Disable time limit'
                              : 'Enable time limit'
                          }
                        >
                          {(aiQuestions?.find((q) => q?.id === question?.id)
                            ?.time_limit || 0) > 0
                            ? 'ON'
                            : 'OFF'}
                        </button>
                      </div>
                      <Input
                        type='number'
                        name='timer'
                        id={`timer${question.id}`}
                        min={10}
                        max={600}
                        step={10}
                        placeholder='60'
                        disabled={
                          (aiQuestions?.find((q) => q?.id === question?.id)
                            ?.time_limit || 0) === 0
                        }
                        value={
                          aiQuestions?.find((q) => q?.id === question?.id)
                            ?.time_limit || 0
                        }
                        onChange={(e) =>
                          updateAiQuestion(
                            question.id,
                            'time_limit',
                            e.target.value
                          )
                        }
                      />
                      <small className='text-muted'>Seconds</small>
                    </FormGroup>
                    <div className='dFlex itemsCenter p-2'>
                      <div className='with-hint item mr-3'>
                        <span>Allow text input</span>
                      </div>
                      <label
                        style={{ minWidth: '52px' }}
                        className={`custom-toggle ${
                          stopInterviewOnTabChange ? ' active' : ''
                        }`}
                      >
                        <input
                          checked={
                            aiQuestions?.find((q) => q?.id === question?.id)
                              ?.allow_input
                          }
                          onChange={(e) =>
                            updateAiQuestion(
                              question.id,
                              'allow_input',
                              aiQuestions?.find((q) => q?.id === question?.id)
                                ?.allow_input === 1
                                ? 0
                                : 1
                            )
                          }
                          type='checkbox'
                          style={{ display: 'none' }}
                        />
                        <span className='custom-toggle-slider rounded-circle' />
                      </label>
                    </div>
                    <Button
                      color='danger'
                      size='sm'
                      onClick={() =>
                        dispatch(
                          setAreYouSureModalData({
                            show: true,
                            customFn: () =>
                              dispatch(
                                setAiQuestions(
                                  aiQuestions.filter(
                                    (q) => q.id !== question.id
                                  )
                                )
                              ),
                          })
                        )
                      }
                      title='Remove question'
                    >
                      <FontAwesomeIcon icon={faTrash} />
                    </Button>
                  </div>
                ))
              : null}

            <button onClick={() => addQuestion()} className='btn btn-info mb-3'>
              Add Question <FontAwesomeIcon icon={faPlus} />
            </button>
          </CardBody>
        </Card>
      </CardBody>
      <Footer />
    </Card>
  )
}

export default SecondSlide
